module.exports = __webpack_public_path__ + "static/technologin-7dafe194f03733d2039fa2edbc28aeff.png";